import { apiClient } from './client'
import type { CurrentUser } from '@/types/user'

export interface LoginResponse {
  access_token: string
  token_type: string
  expires_in: number
  website_type_id: number
  web_parent_id: number
  timezone: string | null
  client_type: string
}

export type SignupReferral = 'NA' | 'Google' | 'Youtube' | 'Facebook' | 'Affiliate' | 'Other'

/** Body of POST /api/signup, the same fields the legacy portal sends. */
export interface SignupPayload {
  firstname: string
  lastname: string
  email: string
  password: string
  referral: SignupReferral
  otherreferral: string
  dropbox_email: string
  secondary_email: string
  /** reCAPTCHA response token; the backend verifies it with Google. */
  recaptcha: string | null
}

export const authApi = {
  login: (useremail: string, password: string) => apiClient.post<LoginResponse>('/api/login', { useremail, password }).then((r) => r.data),
  logout: () => apiClient.post('/api/logout').then((r) => r.data),
  me: () => apiClient.get<CurrentUser>('/api/me').then((r) => r.data),
  signup: (payload: SignupPayload) => apiClient.post<{ status?: boolean; message?: string }>('/api/signup', payload).then((r) => r.data),
  verifyEmail: (emailToken: string) =>
    apiClient.post<{ status: boolean; message?: string }>('/api/verify-email-address', { emailToken }).then((r) => r.data),
  passwordReset: (email: string) => apiClient.post('/api/user/password-reset', { email }).then((r) => r.data),
  changePassword: (password: string) =>
    apiClient.put<{ status: boolean; message: string }>('/api/change-password', { password }).then((r) => r.data),
  switchWebsite: (websiteId: number) =>
    apiClient
      .post<{ handoff_token: string; website_type_id: number; url: string; name: string }>('/api/switch-website', {
        website_type_id: websiteId,
      })
      .then((r) => r.data),
  handoff: (token: string) => apiClient.post<LoginResponse>('/api/auth/handoff', { token }).then((r) => r.data),
}
